export default __webpack_public_path__ + "static/media/021-atom.d6a39c8b.png";